import { render, staticRenderFns } from "./star-empty.vue?vue&type=template&id=60f553ac"
import script from "./star-empty.vue?vue&type=script&lang=js"
export * from "./star-empty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports